import styled from 'styled-components'
import { colors } from '../../../styles/colors'

export const StyledOfficeComponents = styled.div`
.added-row {
  margin-bottom: 40px;
  border-bottom: 1px solid ${colors.gray2};
}

`